import React, {useEffect, useState} from 'react';
import './CheckNationalId.scss';
import DynaInput from "../../../DynaView/DynaInput";
import _axios from "../../../../../httpService";
import {prefixUrl} from "../../../../../utils/utilsData";
import {toast} from "react-toastify";
import DynaButton from "../../../DynaView/DynaButton";
import UtilsFunctions from "../../../../../utils/UtilsFunctions";

const CheckNationalId = ({setOpenAddForm, sendData, setSendData}) => {

  const [personData, setPersonData] = useState({
    status: true,
  });
  const [showInfo, setShowInfo] = useState(false);

  const search = <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#B9B9B9"
      d="M11.5 21.75c-5.65 0-10.25-4.6-10.25-10.25S5.85 1.25 11.5 1.25s10.25 4.6 10.25 10.25-4.6 10.25-10.25 10.25zm0-19c-4.83 0-8.75 3.93-8.75 8.75s3.92 8.75 8.75 8.75 8.75-3.93 8.75-8.75-3.92-8.75-8.75-8.75zM22 22.75c-.19 0-.38-.07-.53-.22l-2-2a.754.754 0 010-1.06c.29-.29.77-.29 1.06 0l2 2c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22z"
    ></path>
  </svg>


  useEffect(() => {
    if (sendData?.nationalId.length === 10) {
      void checkNationalId()
    } else {
      setShowInfo(false)
      setSendData({...sendData, personId: ""})
    }
  }, [sendData?.nationalId]);

  useEffect(() => {
    setShowInfo(false)
    setPersonData({status: true})
  }, [sendData?.personType]);

  const checkNationalId = async () => {

    if (!UtilsFunctions.validateNationalCode(sendData?.nationalId)) {
      return toast.error("اطلاعات را به درستی وارد کنید ")
    }

    const response = await _axios.get(prefixUrl() + `/insurance/?request=getPersonData&personType=` + sendData?.personType + `&nationalId=` + sendData?.nationalId)
    if (response.data.status) {
      setPersonData(response.data)
      setSendData({
        ...sendData,
        personId: response.data.data.id,
        address: response.data.data.address,
        postalCode: response.data.data.postalCode,
        fullName: response.data.data.fullName,
        mobile: response.data.data.mobile,
      })
      setShowInfo(true)
    } else {
      toast.error(response.data.message)
      setPersonData({status: false, data: {}})
      setSendData({...sendData, personId: ""})
      setShowInfo(false)
    }
  }

  return (
    <div className={"nation-check"}>

      <div className={"national-input"}>
        <DynaInput label={`${sendData?.personType === "legal" ? "شناسه" : "کد"} ملی`}
                   name={"nationalId"}
                   className={"solid-dyna-input"}
                   placeholder={`${sendData?.personType === "legal" ? "شناسه" : "کد"} ملی را وارد کنید`}
                   value={sendData?.nationalId}
                   type={"number"}
                   setDataFromComponent={(data) => {
                     if (data.nationalId.length < 11) {
                       setSendData({...sendData, ...data})
                     }
                   }}
        />
        <button className={"search-button"} onClick={checkNationalId}>{search}</button>
      </div>

      {!personData.status ?
        <>
          <p>{sendData?.personType === "legal" ? "شناسه" : "کد"} ملی موردنظر موجود نیست</p>
          <DynaButton className={"insurance-button"}
                      type={"button"}
                      onClick={() => setOpenAddForm(true)}>افزودن شخص</DynaButton>
        </> :
        <ul className={"person-info"}>
          {showInfo ?
            sendData?.personType === "legal" ?
              <>
                <li>
                  <p>نام سازمان :</p>
                  <p>{personData.data?.organizationName}</p>
                </li>
                <li>
                  <p> شناسه ملی :</p>
                  <p>{personData.data?.nationalId}</p>
                </li>
                <li>
                  <p> شماره موبایل :</p>
                  <p>{personData.data?.mobile}</p>
                </li>
              </> :
              <>
                <li>
                  <p>نام و نام خانوادگی :</p>
                  <p>{personData.data?.fullName}</p>
                </li>
                {sendData?.personType === "real-organize" &&
                  <li>
                    <p>نام سازمان :</p>
                    <p>{personData.data?.organizationName}</p>
                  </li>
                }
                <li>
                  <p>کد ملی :</p>
                  <p>{personData.data?.nationalId}</p>
                </li>
                <li>
                  <p> شماره موبایل :</p>
                  <p>{personData.data?.mobile}</p>
                </li>
              </> : <></>}
        </ul>
      }
    </div>
  );
};

export default CheckNationalId;